import api from '../api';


export const CAFETERIA_FINANCES_REQUEST = 'CAFETERIA_FINANCES_REQUEST';
export const CAFETERIA_FINANCES_SUCCESS = 'CAFETERIA_FINANCES_SUCCESS';
export const CAFETERIA_FINANCES_FAIL = 'CAFETERIA_FINANCES_FAIL';

const failedCafeteriaFinances = err => ({
  type: CAFETERIA_FINANCES_FAIL,
  payload: { err },
});

const receiveCafeteriaFinances = ({ date, studentId, ...data }) => ({
  type: CAFETERIA_FINANCES_SUCCESS,
  payload: { ...data, date, studentId },
});

const requestCafeteriaFinances = ({ date, studentId }) => ({
  type: CAFETERIA_FINANCES_REQUEST,
  payload: { date, studentId },
});

/**
 * Загрузить меню школы на день, в которой учится ученик
 *
 * @param studentId id ученика
 * @param date Месяц или день в ISO формате
 */
export function fetchFinances(studentId, date) {
  return async (dispatch) => {
    try {
      dispatch(requestCafeteriaFinances({ studentId, date }));
      const response = await api('cabinet/cafeteria/finances', 'get', { params: { student_id: studentId, date } });
      dispatch(receiveCafeteriaFinances({ data: response.data, studentId, date }));
    } catch (error) {
      dispatch(failedCafeteriaFinances('Не удалось получить историю по финансам'));
    }
  };
}
